// src/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.code-bank.ru',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;
